import { Link } from 'react-router-dom';
import { membershipPlans } from '@/mocks/homeData';

const colorMap: Record<string, { badge: string; button: string; card: string; icon: string }> = {
  primary: {
    badge: 'bg-primary-500 text-white',
    button: 'bg-primary-500 text-white hover:bg-primary-600',
    card: 'border-primary-300 bg-primary-50/50',
    icon: 'text-primary-500',
  },
  accent: {
    badge: 'bg-accent-500 text-background-950',
    button: 'bg-accent-500 text-background-950 hover:bg-accent-600',
    card: 'border-accent-300 bg-accent-50/50',
    icon: 'text-accent-600',
  },
  secondary: {
    badge: 'bg-secondary-500 text-white',
    button: 'bg-secondary-500 text-white hover:bg-secondary-600',
    card: 'border-secondary-200 bg-secondary-50/50',
    icon: 'text-secondary-600',
  },
};

export default function MembershipPlans() {
  return (
    <section id="membership" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-mt-20">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-medium text-primary-500 uppercase tracking-wider">会员服务</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">
            选择适合你的观影方案
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            灵活订阅，自由选择，随时取消，无任何隐藏费用
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {membershipPlans.map((plan) => {
            const colors = colorMap[plan.color];
            return (
              <div
                key={plan.id}
                className={`relative rounded-lg border-2 p-6 md:p-8 flex flex-col transition-all duration-300 ${
                  plan.highlighted
                    ? 'border-primary-400 bg-primary-50/30 shadow-lg shadow-primary-500/10 scale-[1.03]'
                    : `${colors.card}`
                }`}
              >
                {plan.highlighted && (
                  <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full bg-primary-500 text-white text-xs font-bold whitespace-nowrap">
                    最受欢迎
                  </div>
                )}

                <div>
                  <h3 className="text-lg font-heading font-bold text-foreground-950">{plan.name}</h3>
                  <p className="text-xs text-foreground-500 mt-1">{plan.description}</p>
                </div>

                <div className="mt-5 mb-6">
                  <span className="text-4xl font-heading font-bold text-foreground-950">¥{plan.price}</span>
                  <span className="text-sm text-foreground-500 ml-1">/{plan.period}</span>
                </div>

                <ul className="flex-1 space-y-3 mb-8">
                  {plan.features.map((feature) => (
                    <li key={feature} className="flex items-start gap-2.5">
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className={`ri-check-line text-sm ${colors.icon}`}></i>
                      </div>
                      <span className="text-sm text-foreground-600">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Link
                  to="/#membership"
                  className={`w-full py-3 rounded-full text-sm font-semibold text-center transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    plan.highlighted
                      ? 'bg-primary-500 text-white hover:bg-primary-600 shadow-md shadow-primary-500/25'
                      : `${colors.button}`
                  }`}
                >
                  {plan.highlighted ? '立即订阅' : '选择方案'}
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}